import { render, staticRenderFns } from "./MCourseView.vue?vue&type=template&id=d28b4d7e&"
import script from "./MCourseView.vue?vue&type=script&lang=js&"
export * from "./MCourseView.vue?vue&type=script&lang=js&"
import style0 from "./MCourseView.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports